import { type AppScreen } from "@/constants/Screens"
import type { ImageSource } from "expo-image"
import {
  CASH_AVAILABLE_LABELS,
  CREDIT_SCORE_LABELS,
  type PreQualState,
  PROPERTIES_FLIPPED_LABELS,
  RENTALS_OWNED_LABELS,
} from "@/stores/preQual"

export interface QuestionConfigOption {
  value?: string
  label: string
}

export type QuestionValues = keyof PreQualState

function convertHyphenatedToCapitalized(input?: string): string {
  return (
    input
      ?.split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ") || ""
  )
}

export interface QuestionConfig {
  // TODO - Question Key and Value are the same but not. Just two keys for the same object
  questionKey: string
  questionValue: QuestionValues
  questionType: string
  viewAppScreen: AppScreen
  options?: readonly string[] | QuestionConfigOption[]

  // New values
  title?: string
  subTitle?: string
  disclaimer?: string
  displayValue?: (value?: string) => string

  // TODO - Loan Specific - Still to consolidate (if we keep using)
  defaultDateAddDays?: number
  fieldLabel?: string
  image?: ImageSource
}

export const PRE_QUAL_QUESTIONS: readonly QuestionConfig[] = [
  {
    title: "Properties Flipped",
    subTitle:
      "How many investment properties have you purchased and renovated in the last 3 years*?",
    disclaimer:
      "*Excludes primary residences and includes BRRRRs (buy, rehab, rent, refinance, repeat)",
    questionKey: "properties-flipped",
    questionType: "buttons",
    questionValue: "propertiesFlipped",
    viewAppScreen: "PreQual Properties Flipped Question",

    options: PROPERTIES_FLIPPED_LABELS,
  },
  {
    title: "Rentals Owned",
    subTitle: "How many rental properties do you currently own?",
    questionKey: "rentals-owned",
    questionType: "buttons",
    questionValue: "rentalsOwned",
    viewAppScreen: "PreQual Rentals Owned Question",

    options: RENTALS_OWNED_LABELS,
  },
  {
    title: "Estimated Cash Available",
    subTitle: "What is your estimated cash available?",
    questionKey: "cash-available",
    questionType: "buttons",
    questionValue: "cashAvailable",
    viewAppScreen: "PreQual Cash Available Question",

    options: CASH_AVAILABLE_LABELS,
  },
  {
    title: "Credit Score",
    subTitle: "What is your estimated credit score?",
    questionKey: "credit-score",
    questionType: "buttons",
    questionValue: "creditScore",
    viewAppScreen: "PreQual Credit Score Question",

    options: CREDIT_SCORE_LABELS,
  },
  {
    title: "Deal Stage",
    subTitle: "What stage are you at in the process of your next deal?",
    questionKey: "intent-status",
    questionType: "intentStatus",
    questionValue: "intentStatus",
    viewAppScreen: "PreQual Intent Status Question",
    displayValue: convertHyphenatedToCapitalized,

    options: [
      {
        value: "under-contract",
        label: "I have a property under contract",
      },
      {
        value: "property-identified",
        label: "I have a property in mind for funding",
      },
      {
        value: "searching",
        label: "I'm searching for property & lenders",
      },
      {
        value: "researching",
        label: "I'm just researching rates and offers",
      },
      {
        value: "other",
        label: "I'm not looking to fund a new deal",
      },
    ],
  },
]
